import { render, staticRenderFns } from "./IPreactor.vue?vue&type=template&id=3f465381&"
import script from "./IPreactor.vue?vue&type=script&lang=js&"
export * from "./IPreactor.vue?vue&type=script&lang=js&"
import style0 from "./IPreactor.vue?vue&type=style&index=0&id=3f465381&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports